import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  const items = ["Car Wrapping", "Flotte Aziendali", "Oscuramento Vetri", "Stampa Adesivi", "Decorazione Vetrine"];
  return (
    <div className="py-14 lg:py-20 border-y border-brand-border bg-brand-dark overflow-hidden" data-testid="marquee-section">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((it, i) => (
          <div key={i} className="flex items-center">
            <span className="font-anton uppercase text-[8vw] lg:text-[6vw] leading-none px-8 text-stroke">
              {it}
            </span>
            <span className="text-brand-red text-[6vw] lg:text-[4vw] px-2">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
